import { render } from "./TaskPage.vue?vue&type=template&id=ec7fdae6"
import script from "./TaskPage.vue?vue&type=script&lang=js"
export * from "./TaskPage.vue?vue&type=script&lang=js"

import "./TaskPage.vue?vue&type=style&index=0&id=ec7fdae6&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__